/**
 * Composer 작성 폼 트리의 등록형(widget:'registered') 폼 위젯 레지스트리.
 *
 * InputWidget.widgetKey로 이 맵에서 위젯을 찾아 ComposerWidgetTreeView에 주입한다
 * (코어/범용 렌더러에는 도메인 로직 없음 — 미등록 키는 안내 placeholder로 처리).
 *
 * 행 그리드 등록형(field.widget:'registered')은 별도 레지스트리 `COMPOSED_ROW_WIDGETS`
 * (rc registeredRowWidgets — 2026-07-20 rc 이동, web·admin 캔버스 공용).
 *
 * 2026-07-26 web → rc 승격: admin 시뮬레이션이 web 배포판과 같은 레지스트리를 소비해야
 * 하므로(호스트별 조립 드리프트 방지) 이 맵 자체를 rc 정본으로 둔다. web은 재수출층만 유지.
 */
import type { ComposerRegisteredFormWidget } from './composerWidgetTreeRender';
import { COMPOSED_ROW_FORM_WIDGETS } from './rowFormWidgetBridge';
import RiskCriteriaDetailWidget from './RiskCriteriaDetailWidget';

export const COMPOSED_FORM_WIDGETS: Record<string, ComposerRegisteredFormWidget> = {
  // rc 공용 구현(admin 캔버스와 동일 컴포넌트 — WYSIWYG, 개정 5 §4).
  'risk-criteria-detail': RiskCriteriaDetailWidget,
  // 행 위젯(위험도·개선계획)을 폼 위젯 계약으로 브리지 — 반복 행 스코프 배치 시 실렌더(P4b).
  ...COMPOSED_ROW_FORM_WIDGETS,
};
